import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@guildeducationinc/recess';
import { useEffect, useRef } from 'react';
import { useLocale } from '../../hooks/useLocale';
import { getBasePath } from '../../utilities';
import { classNames } from '../../utilities/appHelper';
import { TrackableButton } from '../TrackableButton';
/**
 * Enum representing the types of messages.
 */
export var MessageType;
(function (MessageType) {
    MessageType["ERROR"] = "ERROR";
    MessageType["WARNING"] = "WARNING";
    MessageType["SUCCESS"] = "SUCCESS";
    MessageType["INFO"] = "INFO";
})(MessageType || (MessageType = {}));
/**
 * Formats the parameters of a message.
 * @param intl - The intl object.
 * @param params - The parameters to format.
 * @returns The formatted parameters.
 */
export const formatParams = (intl, params, options = {}) => {
    let retValue;
    if (params) {
        Object.keys(params).forEach(key => {
            if (!retValue) {
                retValue = {};
            }
            if (typeof params[key] === 'function') {
                retValue[key] = params[key]; // Don't format functions
            }
            else if (isNaN(Number(params[key]))) {
                retValue[key] = intl.formatMessage({
                    id: params[key],
                    defaultMessage: `${params[key]}`,
                });
            }
            else if (params[key] instanceof Date) {
                retValue[key] = intl.formatDate(params[key], { dateStyle: 'medium', ...options });
            }
            else {
                retValue[key] = params[key];
            }
        });
    }
    return retValue;
};
const getAlertType = (type) => {
    switch (type) {
        case MessageType.ERROR:
            return 'danger';
        case MessageType.WARNING:
            return 'warning';
        case MessageType.SUCCESS:
            return 'success';
        case MessageType.INFO:
            return 'info';
    }
};
/**
 * Component that displays a list of messages.
 */
export const Messages = (props) => {
    const { t, intl } = useLocale();
    const errorRef = useRef(null);
    useEffect(() => {
        if (props.messages && props.messages.length > 0) {
            setTimeout(() => {
                // auto scroll to the top of the page
                if (errorRef.current) {
                    errorRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            }, 10);
        }
    }, [props.messages]);
    /**
     * Gets the number of messages of a specified type.
     * @param type - The type of message to check.
     * @returns The number of messages of the specified type.
     */
    const numMessages = (type) => {
        return props.messages && props.messages.filter(x => x.type === type).length;
    };
    /**
     * Handles the close event of a message.
     * @param type - The type of message being closed.
     */
    const handleClose = (type) => {
        if (props.onClose) {
            props.onClose(type);
        }
    };
    if (props.messages.length === 0)
        return null;
    return (_jsx("div", { ref: errorRef, className: classNames('flex flex-col gap-3 mt-5 mb-5', props.className ?? ''), children: props.messages &&
            Object.entries(MessageType).map(([_, value], index) => (_jsx(Alert
            // eslint-disable-next-line react/no-array-index-key
            , { display: numMessages(value) > 0, type: getAlertType(value), autoHide: props.autoHide, autoHideTime: props.autoHideTime, hideClose: props.onClose === undefined, handleClose: () => handleClose(value), children: _jsx(Alert.Content, { children: _jsx("ul", { className: classNames('list-inside', numMessages(value) > 1 ? 'list-disc' : ''), children: props.messages
                            .filter(item => item.type === value)
                            .map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        _jsx("li", { children: t(item.value, {
                                values: {
                                    ...formatParams(intl, item.params),
                                    link: (text) => (_jsx(TrackableButton, { btnType: 'link', enText: 'Employer policy', tag: 'payment_request', target: '_blank', href: `${getBasePath()}/reimbursement-policy`, children: text })),
                                },
                            }) }, index))) }) }) }, index))) }));
};
